<template>
  <div id="repo-card">
    <div id="repo-info">
      <div 
        id="repo-avatar"
        :style="{backgroundColor: repo.primaryLanguage ? repo.primaryLanguage.color : '#00ADB5'}"
      >
        <span>{{repo.name[0].toUpperCase() + repo.name[1].toLowerCase()}}</span>
      </div>
      <div id="repo-content">
        <h3 id="repo-name">{{repo.name}}</h3>
        <p id="repo-language">{{repo.primaryLanguage ? repo.primaryLanguage.name : 'UNKNOW'}}</p>
        <p id="repo-description">{{repo.description ? repo.description : 'No description.'}}</p>
      </div>
    </div>
    <div id="repo-sub-info">
      <a id="repo-link" :href="repo.url">Source Code</a>
      <div id="star">
        <v-icon name="star" scale=1.2></v-icon>
        <span>&nbsp;{{repo.starCount}}</span>
      </div>
      <div id="fork">
        <v-icon name="code-branch" scale=1.2></v-icon>
        <span>&nbsp;{{repo.forkCount}}</span>
      </div>
    </div>
    <!-- <div id="repo-topics">
      <b-badge variant="primary">C++</b-badge>
      <b-badge variant="info">Javascript</b-badge>
      <b-badge variant="secondary">big data</b-badge>
      <b-badge variant="success">data science</b-badge>
    </div> -->
    <div id="repo-topics">
      <!-- <span class="ui label medium jordy">Javascript</span>
      <span class="ui label medium sea-pink">Javascript</span>
      <span class="ui label medium sandwisp">Javascript</span>
      <span class="ui label medium fern">Javascript</span> -->
      <p v-if="repo.topics.length === 0" id="placeholder">No Topics</p>
      <span 
        class="ui label medium"
        v-for="(topic, index) in repo.topics"
        :style="{ backgroundColor: badgeColors[index] }"
        v-show="index < 4"
        :key="index"
        @click="viewTopic(topic)"
      >
        {{topic}}
      </span>
    </div>
  </div>  
</template>

<script>
export default {
  data() {
    return {
      badgeColors: ['#8EB9EA', '#F2A095', '#D9D680', '#6FB06F'],
      repo: {}
    }
  },
  props: [
    'repoName'
  ],
  created() {
    this.repo = this.$store.getters.getRepo(this.repoName);
  },
  methods: {
    viewTopic(topic) {
      this.$store.dispatch('updateTopics', [topic]);
    }
  }
}
</script>

<style>
#repo-card {
  height: 264px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  color: #393E46;
  display: flex;
  flex-direction: column;
}

#repo-info {
  display: flex;
  height: 160px;
}

#repo-avatar {
  width: 64px;
  height: 64px;
  color: white;
  text-align: center;
  border-radius: 50%;
  margin: 24px auto 0;
  opacity: 0.75;
}

#repo-avatar span {
  line-height: 64px;
  font-size: 2.5rem;
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
}

#repo-content {
  margin-top: 24px;
  padding-right: 16px;
  width: 70%;
}

#repo-name {
  font-weight: 800;
  font-size: 2rem;
  font-family: Arial, Helvetica, sans-serif;
  margin-bottom: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

#repo-language {
  margin-bottom: 8px;
  font-size: 1rem;
  color: gray;
}

#repo-description {
  font-size: 1.15rem;
  text-overflow: ellipsis;
  display: -webkit-box; 
  -webkit-line-clamp: 3; 
  -webkit-box-orient: vertical;
  /* word-wrap: break-word; */
  overflow: hidden;
  max-height: 5.4rem;
  line-height: 1.8rem;
}

#repo-sub-info {
  display: flex;
  justify-content: space-around;
  align-items: baseline;
  margin: 16px 16px 0;
  font-size: 1rem;
}

#repo-sub-info a {
  font-size: 1.15rem;
}

#repo-sub-info span {
  font-size: 1rem;
}

#repo-sub-info svg {
  font-size: 1rem;
}

#repo-link, #repo-link:hover {
  color: #00ADB5;
  text-decoration: none;
}

#star {
  color: #FAD25A;
}

#star span {
  color: #393E46;
}

#fork {
  color: #FAD25A;
}

#fork span {
  color: #393E46;
}

#repo-topics {
  width: 85%;
  margin: 16px auto;
  height: 25px;
  overflow: hidden;
}

#repo-topics span { 
  margin-left: 3px;
  margin-right: 3px;
  margin-bottom: 8px;
  padding: 4px 6px;
  color: white;
  cursor: pointer;
}

/* #repo-topics span.jordy {
  background-color: #8EB9EA;
}

#repo-topics span.sea-pink {
  background-color: #F2A095;
}

#repo-topics span.sandwisp {
  background-color: #D9D680;
}

#repo-topics span.fern {
  background-color: #6FB06F;
} */

#placeholder {
  color: #bbb;
  text-align: center;
  font-size: 18px;
  font-weight: 200;
  font-family: BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif
}

@media screen and (max-width: 564px) {
  #repo-avatar {
    width: 56px;
    height: 56px;
    margin: 16px auto 0;
  }

  #repo-avatar span {
    line-height: 56px;
    font-size: 2.25rem;
  }

  #repo-content {
    margin-top: 16px;
    padding-right: 16px;
    width: 70%;
  }

  #repo-card {
    height: 256px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    color: #393E46;
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RepoCard.vue